import axios from "axios";

(function() {
    const element = <HTMLElement>document.querySelector('[data-flight-search-redirect]');
    if (element) {
        const maximumExecutionTime = 30000
        let queryParams = new URLSearchParams(window.location.hash.substring(1));
        const start = Date.now()
        const flightIbeUrl = element.getAttribute('data-flight-ibe-url')

        const redirect = (fareSearchId: string|void) => {
            queryParams.delete('flightSearchId')
            if (fareSearchId) {
                queryParams.set('fareSearchId', fareSearchId)
            }
            window.location.replace(flightIbeUrl + '#/deeplink/clearStorage?' + queryParams.toString())
        }

        const checkFlightSearch = (flightSearchId: string) => {
            axios.get('/api/flight-searches/' + flightSearchId)
                .then(res => {
                    if (res.data.meta.fareSearchId) {
                        redirect(res.data.meta.fareSearchId)
                    } else {
                        if (start + maximumExecutionTime > Date.now()) {
                            setTimeout(() => checkFlightSearch(flightSearchId), 1000)
                        } else {
                            redirect()
                        }
                    }
                })
                .catch(res => {
                    redirect()
                })
        }
        if (queryParams.has('flightSearchId')) {
            checkFlightSearch(queryParams.get('flightSearchId'))
        } else {
            redirect()
        }
    }
}());
